export const GREEN = '#23D7B6';
export const BLUE = '#1166EC';
export const YELLOW = '#FCAF33';
export const ORANGE = '#FD5228';
export const RED = '#A81E0F';

const CHART_COLORS = [GREEN, BLUE, YELLOW, ORANGE, RED];

export default CHART_COLORS;
